var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"form-submit",class:{loading: _vm.loading},attrs:{"type":_vm.type,"disabled":_vm.loading}},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.loading)?_c('Loader',{attrs:{"is-active":_vm.loading}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }